<div class="search-container" [class.search-container--fixed]="searchContainerFixed">
  <div #scrollZone class="search-container__title container">
    <ng-content select="h1"></ng-content>
  </div>

  <div class="search-container__inner">
    <div class="container">
      <div #searchEngine class="search-container__body">
        <div
          #shadowbox
          class="search-container__body__shadowbox"
          [ngStyle]="{ webkitTransform: shadowboxTransform, transform: shadowboxTransform }"
        ></div>
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
